import { useState } from "react";
import { Button, Input } from "../ui";
import { scheduleSubscriptionCancellationAPI } from "../../utils/api/billing";

// renewalReasonModal equivalent: capture a reason, schedule cancellation at
// period end (does not refund or cancel the current paid period).
const StopSubscriptionModal = ({ subscriptionId, lang, text, onCancel, onDone }) => {
  const token = localStorage.getItem("auth-token");
  const isRtl = lang !== "en";
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (submitting) return;
    if (!reason.trim()) {
      setError(text.stopReasonLabel);
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await scheduleSubscriptionCancellationAPI(token, subscriptionId, { reason });
      await onDone();
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="billing-modal-backdrop" dir={isRtl ? "rtl" : "ltr"}>
      <div className="billing-modal">
        <h3>{text.stopModalTitle}</h3>
        {error && <div className="billing-error">{error}</div>}
        <Input
          label={text.stopReasonLabel}
          textarea
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder={text.stopReasonPlaceholder}
        />
        <div className="billing-modal-actions">
          <Button
            appearance="filled"
            variant="danger"
            loading={submitting}
            disabled={submitting}
            onClick={submit}
          >
            {text.confirmStop}
          </Button>
          <Button appearance="ghost" disabled={submitting} onClick={onCancel}>
            {text.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StopSubscriptionModal;
